module.exports = __webpack_public_path__ + "static/media/S1N5-2.56810a64.svg";